// null-safe string helpers — defends against shows / users with missing
// fields that previously crashed pages (`null.toLowerCase()` → black screen).

export const lower = (v) => (v == null ? "" : String(v).toLowerCase());
